import { 
  ArrowPathIcon,
  ArrowsRightLeftIcon, 
  BookmarkIcon
} from '@heroicons/react/24/outline'

import AppLogo from "../apps/logo"



export default function ConnectionsListItem(
  { 
    item, // app_connection 
    tag="h3", 
  }:
  { 
    item: { 
      id?: number, // will be empty for synthetic connection
      app: {
        slug: string,
        name: string, 
      }, 
      connection: {
        slug: string,
        name: string, 
        title: string,
        description: string, 
        image_updated_at: string, 
        is_opensource: boolean, 
        count_sources_automation: number, 
        count_alternatives_published: number, 
        primary_category: {
          name: string 
        }
      }      
    }, 
    tag?: "p" | "h2" | "h3", 
  }
) {

  
  const { app, connection } = item 
  const CardTitleTag = tag || "h2"


  const appConnectionUrl = `/${app?.slug}/integrations/${connection?.slug}`
  const connectionUrl = `/${connection?.slug}`

  const cardTitle = connection?.name
  const cardSubtitle = connection?.title || connection?.primary_category?.name
  const cardDescription = connection?.description

  const showCardMain = item?.id ? true : false  // dont show for synthetic 

  return (
    <div className="border border-gray-200 rounded bg-white">
      {/* Card Header */}
      <div className="border-b border-gray-200 px-4 py-5 sm:px-6">
        <div className="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="ml-4 mt-4">
            <div className="flex items-center space-x-3">
              
              <div className="flex-shrink-0">
                <a href={connectionUrl}>
                  <AppLogo app={connection} className="h-12 w-12 rounded" />
                </a>
              </div>
              
              <div className="">                
                <CardTitleTag className="inline text-base font-semibold leading-6 text-gray-900">
                  <a href={appConnectionUrl}>
                    {cardTitle}
                  </a>
                </CardTitleTag>

                {connection?.is_opensource ? (
                  <span className="ml-3 inline-flex items-center rounded-full  px-2  text-sm bg-white text-crisp-600 border border-crisp-500">
                    opensource
                  </span>
                ) : null}

                <p className="text-sm text-gray-500">
                  { cardSubtitle }
                </p>

              </div>
            </div>
          </div>

          <div className="ml-4 mt-4 flex flex-shrink-0">
            
            <button
              type="button"
              aria-label="Save"
              disabled={true}
              className="relative inline-flex items-center rounded bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              <BookmarkIcon className=" h-5 w-5 text-gray-400" aria-hidden="true" />
            </button>
            
            <a
              href={appConnectionUrl}
              className="relative ml-3 inline-flex items-center rounded bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              <ArrowPathIcon className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span>View Integration</span>
            </a>
            
            <a
              href={connectionUrl}
              className="relative ml-3 inline-flex items-center rounded bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              <span>View Profile</span>
            </a>

          </div>
        </div>
      </div>
      
      {/* Card Content */}
      {showCardMain ? (

        <div className="px-4 sm:px-6 py-3 text-sm">

          {cardDescription ? (        
            <p className="py-3">
              {cardDescription}
            </p>
          ) : null}


          <div className="flex flex-wrap gap-x-3 ">
            {connection?.count_alternatives_published > 0 ? (
              <a
                href={`/${connection?.slug}/alternatives`}
                className="group space-x-1 text-gray-500 py-3">
                <span className="font-semibold  text-crisp-600">
                  {connection?.count_alternatives_published}
                </span>
                <span className="group-hover:underline">
                  alternatives
                </span>
              </a>
            ) : null}

            {connection?.count_sources_automation > 0 ? (
              <a
                href={`/${connection?.slug}/integrations`}
                className="group space-x-1 text-gray-500 py-3"
              >
                <span className="font-semibold  text-crisp-600">
                  {connection?.count_sources_automation}
                </span>
                <span className="group-hover:underline">
                  workflow automation platforms supported
                </span>
              </a>
            ) : null}        
          </div>

          
          {/* {item?.common_categories?.length > 0 ? (
            <div className="space-y-3">
              <p className=" text-gray-500">
                <span className="font-semibold  text-crisp-600">
                  {item?.common_categories?.length}
                </span>                            
                {` `} Common categories with {app?.name}:
              </p>
              <p className="space-x-2">
                {item?.common_categories?.map(category => (
                  <a
                    className="text-gray-500 hover:underline"
                    href={`/${category?.slug}`}
                    key={category?.name}>
                    {category?.name}
                  </a>
                ))}              
              </p>
            </div>
          ) : null} */}

  
        </div>
      ) : null}
    </div>
  ) 

}